<style scoped>
.emptyBox {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.emptyImg {
  width: 4.03rem;
  height: 3.28rem;
  background: url("~assets/artHealing.png") no-repeat center/cover;
  margin-top: 2rem;
  margin-bottom: 0.62rem;
  font-size: 0.3rem;
  color: #6f6f6f;
}
.emptyName {
  font-size: 0.32rem;
  color: #000;
}
</style>
<style src="css/courseList.css" scoped></style>
<template>
  <div style="padding-top: 0.98rem; background: #fff; min-height: 100vh">
    <topbar text="我的课程"></topbar>
    <div class="emptyBox" v-if="emptyStatus">
      <div class="emptyImg"></div>
      <div class="emptyName">你还没有课程哦~</div>
    </div>
    <ul class="courseList" v-if="!emptyStatus">
      <li
        v-for="(item,index) in MicroList" :key="index"
        @click="to(`courseDetail?microId=${item.microId}&orderNo=${item.orderNo}`)"
      >
        <div class="itemLeftBox">
          <div class="itemTitle">{{ item.name }}</div>
          <div class="itemTimeBox">
            {{ item.createTime | time }}
          </div>
        </div>
        <div
          class="itemRightBox"
          :style="{ background: `url(${item.pic}) no-repeat center/cover` }"
        >
          <!--                    <div class="free">免费</div>-->
          <!--                    <div class="vip"></div>-->
        </div>
      </li>
      <no-more-data :noMoreData="noMoreData"></no-more-data>
    </ul>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import moment from "moment/moment";

import { Swiper, Slide } from "vue-swiper-component";
import { serialize } from "utils/index";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      MicroList: [],
      pageIndex: 1,
      pageSize: 10,
      noMoreData: false,
      isLoading: false,
      emptyStatus: false,
      count: 0,
      userId: "",
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    selectScale(id, testId) {
      if (this.bookStatus) {
        this.$router.push(`/result?testId=${testId}`);
      } else {
        this.$router.push(`/testDetail?scaleId=${id}&testId=${testId}`);
      }
    },
    to(n) {
      this.$router.push(`/${n}`);
    },
    getList(index) {
      this.bookStatus = index;
      this.pageIndex = 1;
      this.MicroList = [];
      this.noMoreData = false;
      this.isLoading = false;
      this.emptyStatus = false;
      this.getMyMicro();
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let bottomOfWindow =
        document.documentElement.offsetHeight -
          scrolltop -
          window.innerHeight <=
        200;
      if (bottomOfWindow && this.isLoading == false) {
        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
          this.noMoreData = true;
        } else {
          this.isLoading = true;
          this.pageIndex = this.pageIndex + 1;
          this.getMyMicro();
        }
      }
    },
    async getMyMicro() {
      let obj = {};
      obj.pageIndex = this.pageIndex;
      obj.pageSize = this.pageSize;
      obj.userId = this.userId;
      //   obj.bookStatus = this.bookStatus;
      let data = await getSources(
        "/bear-scale/api/scaleUserMicro/getMyMicro",
        obj
      );
      if (data.status === 0) {
        this.isLoading = false;
        this.count = data.count;
        this.MicroList = [...this.MicroList, ...data.MicroList];
        if (data.MicroList.length == 0) {
          this.emptyStatus = true;
        } else {
          console.log(111111);
          if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
            console.log("显示");
            this.noMoreData = true;
          } else {
            console.log(2);
            this.noMoreData = false;
          }
        }
      } else {
        alert(data.msg);
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    this.userId = localStorage.getItem("userId");
    if (!localStorage.getItem("userId") && this.$route.path !== "/login") {
      if (this.$route.query.code) {
        this.$router.push(
          `/welcome?next=${encodeURIComponent(this.$route.fullPath)}&code=${
            this.$route.query.code
          }`
        );
      } else {
        this.$router.push(
          `/welcome?next=${encodeURIComponent(this.$route.fullPath)}`
        );
      }
    }
    //            if (this.$route.query.bookStatus == 0 || this.$route.query.bookStatus == 1) {
    //                this.bookStatus = this.$route.query.bookStatus
    //            }
    this.getMyMicro();
    window.addEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
};
</script>



// WEBPACK FOOTER //
// src/components/myCourse.vue?09706fcd